import React from "react";
import { connect } from "react-redux";
import {
  StyledForm,
  FormGroup,
  UpgradeText,
  ChannelFormSection,
  FieldHead,
  UpgradeButtonLink,
  UpgradeButtonLinkContainer,
} from "./styledComponents";
import Button from "components/Button";
import { ColorPickerButton } from "components/InputField/File";
import { toast, ToastContainer } from "react-toastify";
const notify = () => toast("Changes Saved!");
import { Field } from "redux-form";
import { ChannelInputField } from "./components";
import Divider from "components/Divider";

export const MessagingForm = ({
  edit,
  submitting,
  openColorPickerModal,
  messageForm,
  handleSubmit,
  permissionRole,
  nextTab,
}) => {
  const formOptions = [
    {
      header: "Email Messaging",
      description:
        "Customize the messaging you’d like guests to see when they receive their images by email.",
      label: "Email Messaging",
      eligibleTiers: ["plus", "pro", "super_admin", "enterprise_admin"],
      upgradeButton: (
        <div style={{ marginTop: "20px" }}>
          <UpgradeButtonLinkContainer>
            <UpgradeButtonLink href="mailto:sales@movebooth.com?&subject=Movebooth%20Account%20Upgrade%20Request&body=I'd Like to upgrade to set email subject, body copy, and call-to-action!" target="_blank" rel="noreferrer noopener">
              Upgrade to set email subject, body copy, and call-to-action
            </UpgradeButtonLink>
          </UpgradeButtonLinkContainer>
        </div>
      ),
      subFields: [
        {
          name: "email_subject_line",
          label: "Email Subject",
          placeholder: "📸 Your Hooli selfie from Movebooth is here!",
          type: "text",
          eligibleTiers: ["plus", "pro", "super_admin", "enterprise_admin"],
        },
        {
          name: "email_copy",
          label: "Email Body Copy",
          placeholder:
            "Add copy to the body of your emails. Leave this field blank if you don’t want copy in the body of your emails.",
          type: "text",
          eligibleTiers: ["pro", "super_admin", "enterprise_admin"],
          multiline: 5,
          upgradeButton: (
            <div style={{ marginTop: "20px" }}>
              <UpgradeButtonLinkContainer>
                <UpgradeButtonLink href="mailto:sales@movebooth.com?&subject=Movebooth%20Account%20Upgrade%20Request&body=I'd Like to upgrade to add body copy and call-to-action!" target="_blank" rel="noreferrer noopener">
                  Upgrade to add body copy and call-to-action
                </UpgradeButtonLink>
              </UpgradeButtonLinkContainer>
            </div>
          ),
        },
        {
          name: "email_cta_text",
          label: "CTA Button Label",
          placeholder: "Get 10% Off Your Next Purchase",
          type: "text",
          eligibleTiers: ["pro", "super_admin", "enterprise_admin"],
        },
        {
          name: "email_cta_link",
          label: "CTA Button URL",
          placeholder: "https://www.yourstore.com/movebooth",
          type: "text",
          eligibleTiers: ["pro", "super_admin", "enterprise_admin"],
          upgradeButton: null,
        },
        {
          name: "email_cta_button_color",
          label: "cta button background color",
          type: "color",
          defaultColor: "#F90185",
          eligibleTiers: ["pro", "super_admin", "enterprise_admin"],
          colorPreviewOnLeft: true,
          upgradeButton: null,
        },
        {
          name: "email_cta_button_text_color",
          label: "cta button text color",
          type: "color",
          defaultColor: "#FFFFFF",
          colorPreviewOnLeft: true,
          eligibleTiers: ["pro", "super_admin", "enterprise_admin"],
          upgradeButton: null,
        },
      ],
    },
    {
      header: "Text Messaging",
      description:
        "Customize the messaging you’d like guests to see when they receive their images by text message.",
      label: "Text Messaging",
      eligibleTiers: ["plus", "pro", "super_admin", "enterprise_admin"],
      upgradeButton: (
        <div style={{ marginTop: "20px" }}>
          <UpgradeButtonLinkContainer>
            <UpgradeButtonLink href="mailto:sales@movebooth.com?&subject=Movebooth%20Account%20Upgrade%20Request&body=I'd like to upgrade to set text message copy!" target="_blank" rel="noreferrer noopener">
              Upgrade to set text message copy
            </UpgradeButtonLink>
          </UpgradeButtonLinkContainer>
        </div>
      ),
      subFields: [
        {
          name: "phone_copy",
          label: "text message copy",
          eligibleTiers: ["pro", "plus", "super_admin", "enterprise_admin"],
          placeholder:
            permissionRole === "pro"
              ? "📸 Your Hooli selfie from Movebooth is here! Get 10% off your next purchase at https://www.yourstore.com/movebooth"
              : "📸 Your Hooli selfie from Movebooth is here!",

          type: "text",
          upgradeButton: (
            <div style={{ marginTop: "20px" }}>
              <UpgradeButtonLinkContainer>
                <UpgradeButtonLink href="mailto:sales@movebooth.com?&subject=Movebooth%20Account%20Upgrade%20Request&body=I'd like to upgrade to add URL link support to text messages!" target="_blank" rel="noreferrer noopener">
                  Upgrade to add URL link support to text messages
                </UpgradeButtonLink>
              </UpgradeButtonLinkContainer>
            </div>
          ),
          multiline: 5,
        },
      ],
    },
    {
      header: "Twitter Messaging",
      description:
        "Customize the messaging you’d like guests to see when receive their images by Twitter.",
      label: "Twitter Messaging",
      eligibleTiers: ["plus", "pro", "super_admin", "enterprise_admin"],
      upgradeButton: (
        <div style={{ marginTop: "20px" }}>
          <UpgradeButtonLinkContainer>
            <UpgradeButtonLink
              margin="20px 0px"
              href="mailto:sales@movebooth.com?&subject=Movebooth%20Account%20Upgrade%20Request&body=I'd like to upgrade to set Twitter copy!"
              target="_blank" rel="noreferrer noopener"
            >
              Request to upgrade to set Twitter copy
            </UpgradeButtonLink>
          </UpgradeButtonLinkContainer>
        </div>
      ),
      subFields: [
        {
          name: "twitter_copy",
          label: "tweet copy",
          eligibleTiers: ["pro", "plus", "super_admin", "enterprise_admin"],
          placeholder:
            permissionRole === "pro"
              ? "📸 Your Hooli selfie from Movebooth is here! Get 10% off your next purchase at https://www.yourstore.com/movebooth"
              : "📸 Your Hooli selfie from Movebooth is here!",

          type: "text",
          multiline: 5,
          upgradeButton: (
            <div style={{ marginTop: "20px" }}>
              <UpgradeButtonLinkContainer>
                <UpgradeButtonLink
                  href="mailto:sales@movebooth.com?&subject=Movebooth%20Account%20Upgrade%20Request&body=I'd Like to upgrade to add URL link support to Tweets!"
                  margin="0px 0px 20px 0px" target="_blank" rel="noreferrer noopener"
                >
                  Request to upgrade to add URL link support to Tweets
                </UpgradeButtonLink>
              </UpgradeButtonLinkContainer>
            </div>
          ),
        },
      ],
    },
  ];

  return (
    <StyledForm onSubmit={handleSubmit}>
      <ToastContainer />
      {formOptions.map((options, idx) => {
        const {
          header,
          description,
          type,
          subFields,
          eligibleTiers,
          upgradeButton,
        } = options;
        return (
          <FormGroup key={idx}>
            <ChannelFormSection>
              {(header || description) && type !== "upgrade" && (
                <FieldHead className="brand">
                  <strong>{header}</strong>
                  <h3 className="customize-the-message">{description}</h3>
                </FieldHead>
              )}
              {eligibleTiers.includes(permissionRole) ? (
                subFields &&
                subFields
                  .filter((x) => x)
                  .map((options, idx) => {
                    if (
                      options.eligibleTiers &&
                      options.eligibleTiers.includes(permissionRole)
                    ) {
                      switch (options.type) {
                        case "color":
                          const value =
                            messageForm[options.name] || options.defaultColor;
                          return (
                            <div key={idx} className="field-file">
                              <Field
                                name={messageForm[options.name]}
                                component={ColorPickerButton}
                                onClick={openColorPickerModal}
                                buttonText={value}
                                backgroundColor={value}
                                {...options}
                              />
                            </div>
                          );
                        default:
                          return (
                            <div key={idx} className="field-text">
                              <Field
                                name={messageForm[options.name]}
                                component={ChannelInputField}
                                {...options}
                              />
                              {permissionRole === "plus" &&
                                options.upgradeButton}
                            </div>
                          );
                      }
                    } else return <div key={idx}>{options.upgradeButton}</div>;
                  })
              ) : (
                <div key={idx}>{upgradeButton}</div>
              )}
            </ChannelFormSection>
          </FormGroup>
        );
      })}
      <Divider marginBottom={48}></Divider>
      <UpgradeText className="left-pos pdd-20">
        Looking for more? Send us a suggestion.
      </UpgradeText>
      <div className="channel-forms__group">
        {edit ? (
          <Button type="submit" onClick={notify} disabled={submitting}>
            Save
          </Button>
        ) : (
          <Button type="button" onClick={() => nextTab()}>
            Save & Continue
          </Button>
        )}
      </div>
    </StyledForm>
  );
};

export default MessagingForm;



// WEBPACK FOOTER //
// ./src/containers/ChannelsPage/Forms/MessagingOptionForm.js